import * as React from 'react';
const OcchiRossiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M52 99.99c8.35-19.11 27.19-31.44 48-31.44s39.65 12.34 48 31.44c-8.35 19.11-27.19 31.45-48 31.45S60.35 119.1 52 99.99"
      className="prefix__cls-2"
    />
    <circle
      cx={100}
      cy={100}
      r={24.83}
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
    <path
      d="M114.9 100c0 8.24-6.65 14.9-14.9 14.9s-14.9-6.65-14.9-14.9c0-1.06.1-2.09.33-3.08a8.3 8.3 0 0 0 4.64 1.42c4.57 0 8.28-3.71 8.28-8.28 0-1.72-.53-3.31-1.42-4.64.99-.23 2.02-.33 3.08-.33 8.24 0 14.9 6.65 14.9 14.9Z"
      className="prefix__cls-2"
    />
  </svg>
);
export default OcchiRossiIcon;
